const style = {
    progressCircleBorder: {
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
    },
    noReviewsBorder: {
        width: "100%",
        justifyContent: "start"
    }

}

export default style;